<template>
  <extended-entity-edit ref="list"
                        :formConfig="formConfig"
                        :entityId="entityId"
                        :mode="mode"

                        @entity-instance-loaded="setInstance"
                        @form-created="masterFormSet"
                        @form-loaded="masterFormLoaded"
                        @cancel="close"
                        @saved="saved"

                        :toolbox-mixins="toolboxMixins"
                        v-model="unsavedChanges"
                        :preset-fields = "presetFields"
                        :context = "context"
                        :details-config="detailsConfig"
                        :master-form-config="masterFormConfig"
                        :master-id="masterId"
                        :temporary-extension-to-set="temporaryExtensionToSet"
                        :temporary-instance-to-edit="temporaryInstanceToEdit"
                        :temporary-list-to-add="temporaryListToAdd"
                        :custom-add="customAdd"
                        :show-footer-navbar="showFooterNavbar"
                        :disable-close="disableClose"
                        :show-header="showHeader"
                        :custom-style-for-fluid-container="customStyleForFluidContainer"
                        @click-on-info="bubble('click-on-info', $event)"
  >
    <slot name="mixins">

    </slot>

    <template v-slot:custom-details>
      <slot name="custom-details"></slot>
    </template>

  </extended-entity-edit>
</template>
<script>
import Perms from "@/server/Perms";
import FormConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormConfig";
import Activity from "@/activity/Activity";
import FormsAI from "@/components/forms/FormsAI";
import ExtendedEntityEdit from "@/components/forms/ExtendedEntityEdit";
import FormDetailsConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig";
import DialogManager from "@/utils/DialogManager";
import TemporaryList from "@/components/forms/TemporaryList"
import FormsLoader from "@/components/forms/FormsLoader";
import ActivityManager from "@/activity/ActivityManager";
import BaseFormConfig from "@/server/com/silkplm/engine/forms/schema/BaseFormConfig";
import TemporaryExtension from "@/components/forms/TemporaryExtension";
import EntityEditForm from "@/components/forms/EntityEditForm.vue";


export default {
  name: "FormEditActivity",
  permission: null,
  components: {EntityEditForm, ExtendedEntityEdit},
  async beforeMount() {
    this.permission = this.formConfig.restrictedList ? Perms[this.formConfig.effectivePermissionRead] : null;
  },

  async mounted() {
    // override oarent getTitle
    const aClazz = Activity;

    if(!this.$parent.getTitle || this.$parent.getTitle(true) === true) {
      this.$parent.getTitle = () => {
        if(this.instance) {
          this.title = FormsAI.getEntityLabel(this.formConfig, this.instance);
        }
        return this.getTitle();
      }
    }
    this.activity = ActivityManager.findActivity(this.$el);
  },

  created() {
  },


  methods: {
    bubble(ev, data) {
      if(!data){
        this.$emit(ev);
      }
      this.$emit(ev, data);
    },

    masterFormLoaded(){
      this.$emit("form-loaded");
    },

    /**
     * @param form {FormModel}
     */
    masterFormSet(form){
      this.$emit("update:form", form);
      this.$emit("form-created", form);
      form.onChange(() => {
        this.activity?.refreshTitle();
      });
      this.activity?.refreshTitle();
    },
    setInstance(instance){
      this.instance = instance;
      this.title = FormsAI.getEntityLabel(this.formConfig, instance);
      ActivityManager.findActivity(this)?.refreshTitle();
    },

    getTitle() {
      if (this.mode === "NEW") {
        return "New " + this.formConfig.entityName;
      } else {
        return this.title;
      }
    },

    saved(data){
      this.$emit("saved", data);
    },

    beforeClose() {
      if(this.instance){
        this.setResult(this.instance);
      }
    },

    async cancel() {
      await this.close();
    },

    async close(){
      let wnd = this.$refs.list;
      if(wnd.willReopen?.()){
        let res = await ActivityManager.closeTopActivityForReopen();
        wnd.activityClosed?.();
        return res;
      } else {
        let res = await ActivityManager.closeTopActivity();
        return res;
      }
    },

    async canClose(){
      return this.$refs.list.canClose();
    }
  },

  props: {
    formType: {required:true},
    entityId: {type: String, default: ""},
    mode: {type: String, default: null},
    presetFields: {default: null},
    context: {default:null},
    detailsConfig: {type: FormDetailsConfig, default: null},
    masterFormConfig: {type: BaseFormConfig, default: null},
    masterId: {type:String, default: null},
    temporaryExtensionToSet: {type:TemporaryExtension, default:null },
    temporaryListToAdd: {type:TemporaryList, default:null },
    temporaryInstanceToEdit : {default:null},
    customAdd: {default: false},
    toolboxMixins: {type: Array, default: () => []},
    showFooterNavbar: {type: Boolean, default: true},
    disableClose: {type: Boolean, default: false},
    showHeader: {type: Boolean, default: true},
    customStyleForFluidContainer: {default: ""},
  },

  data: function(){ return {
    formId: FormsLoader.detectFormConfig(this.formType).formId,
    formConfig: FormsLoader.detectFormConfig(this.formType),

    instance: null,
    title: '',
    unsavedChanges: false
  }},
}
</script>
